import { extendTheme } from "@chakra-ui/react";

import { checkboxAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(checkboxAnatomy.keys);

const baseStyle = definePartsStyle({
  // define the part you're going to style
  label: {
    fontFamily: "mono", // change the font family of the label
    fontSize: "24px",
  },
  control: {
    // padding: 3, // change the padding of the control
    borderRadius: 0, // change the border radius of the control
    rounded: "full",
    color: "black",
  },
});

const checkboxTheme = defineMultiStyleConfig({ baseStyle });

const theme = extendTheme({
  fonts: {
    heading: `'Circular', 'Open Sans', sans-serif`,
    body: `'Circular', sans-serif`,
  },
  components: { Checkbox: checkboxTheme },
});

export default theme;
